import { useState, useRef, useEffect, EffectCallback, DependencyList } from "react";
import { DATE_MAX_STRING, DATE_MIN_STRING } from "@/shared/config/globals";
import { HYPHEN_CANDIDATES } from "@/shared/config/constants";
import moment from "moment";

export const utilities = () => {
  // TODO:テキストフィールドのStateはdictで持たない方針のため修正必須
  // バリデーションチェック
  const validateForm = (
    validators: { [key: string]: ((...args: unknown[]) => string| undefined)[] },
    // validators: { [key: string]: Function[] }, // ←修正前↑修正後：あってるかわからないためコメントとして残す
    form: { [key: string]: unknown },
    formError: { [key: string]: string },
    setFormError: any,
  ): boolean => {
    let hasError = false;
    const errorCopy = {
      ...formError,
    };

    Object.entries(form).map(([key, value], i) => {
      let error = "";
      const fieldValidators = validators[key] || [];
      fieldValidators.map((v, i) => {
        if (error) return null;
        error = v(value) || "";
        return null;
      });
      errorCopy[key] = error;

      if (error) hasError = true;
      return null;
    });
    setFormError(errorCopy);
    return !hasError;
  };

  // TODO:下記のように修正
  // setStateはControllerで行う。共通関数ではエラーかどうかの判断のみ
  // 「エラーかどうか」、何がエラーになったかkeyのリストを返すよう修正
  // 複数のフォームのバリデーションチェック
  const validatesForms = (
    validators: { [key: string]: ((...args: string[]) => string| undefined)[] },
    // validators: { [key: string]: Function[] }, // ←修正前↑修正後：あってるかわからないためコメントとして残す
    values: { [key: string]: any },
    setStates: { [key: string]: React.Dispatch<React.SetStateAction<string>> },
  ) => {
    let hasError = false;
    Object.entries(values).map(([key, value], i) => {
      const result = validatesForm(validators[key], value, setStates[key]);

      if (!result) hasError = true;
    });
    return !hasError;
  };

  // 単体フォームのバリデーションチェック
  const validatesForm = (
    validator: ((...args: string[]) => string| undefined)[],
    // validators: Function[], // ←修正前↑修正後：あってるかわからないためコメントとして残す
    value: string,
    setState: React.Dispatch<React.SetStateAction<string>>,
  ) => {
    let hasError = false;
    let error = "";
    validator.map((v, i) => {
      if (error) return null;
      error = v(value) || "";
    });
    setState(error);

    if (error) hasError = true;

    return !hasError;
  };

  // ローカルストレージへのアクセス
  const accessLocalStorage = (keyName: string, defaultValue: string) => {
    const [storedValue, setStoredValue] = useState(() => {
      try {
        const value = window.localStorage.getItem(keyName);
        if (value) {
          return JSON.parse(value);
        } else {
          window.localStorage.setItem(keyName, JSON.stringify(defaultValue));
          return defaultValue;
        }
      } catch (err) {
        return defaultValue;
      }
    });
    const setValue = (newValue: string) => {
      try {
        window.localStorage.setItem(keyName, JSON.stringify(newValue));
      } catch (err) {
        console.error("failed to stor evalue");
      }
      setStoredValue(newValue);
    };
    return [storedValue, setValue];
  };

  // 日付操作 =============================================================
  // YYYYMMDD → Date
  const toDate = (s: string): Date => {
    return new Date(
      Number(s.slice(0, 4)),
      Number(s.slice(4, 6)) - 1,
      Number(s.slice(6, 8))
    );
  };

  // Date → YYYYMMDD
  const toYYYYMMDD = (d: Date): string => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}${m}${day}`;
  };

  // 年を加減算
  const addYears = (d: Date, years: number): Date => {
    const newDate = new Date(d);
    newDate.setFullYear(newDate.getFullYear() + years);
    return newDate;
  };

  // 1日加算
  const addDays = (dateStr: string, days: number): string => {
    const d = new Date(
      Number(dateStr.slice(0, 4)),
      Number(dateStr.slice(4, 6)) - 1,
      Number(dateStr.slice(6, 8))
    );
  
    d.setDate(d.getDate() + days);
  
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
  
    return `${y}${m}${day}`;
  };

  // 1日後
  const getNextDay = (dateStr: string): string => {
    return addDays(dateStr, 1);
  };

  // 1日前
  const getPreviousDay = (dateStr: string): string => {
    return addDays(dateStr, -1);
  };

  /**
   * Todo: patternの種類はconst・type化して、利用側から選択しやすいように修正する
   *        formatの初期値は一番多く使われているものにする
   *        このファイル内で日付のフォーマットを整形している他の部分もこの関数を使うようにする
   *        曜日もフォーマットできるよう修正する
   *
   * Dateオブジェクトを任意の文字列でフォーマットする
   * @param {string | Date} date
   * @param {string} pattern 取得したい年月日時分をsymbolで表したもの("yyyy-MM-ddThh:mm"等)
   * @returns {string} 任意の日付文字列
   */
  const getFormattedDate = (date: string | Date, pattern: string) => {
    const targetDate = typeof date === "string" ? new Date(date) : date;

    const symbol = {
      M: targetDate.getMonth() + 1,
      d: targetDate.getDate(),
      h: targetDate.getHours(),
      m: targetDate.getMinutes(),
      s: targetDate.getSeconds(),
    };

    const formatted = pattern.replace(/(M+|d+|h+|m+|s+)/g, (v) =>
      ((v.length > 1 ? "0" : "") + symbol[v.slice(-1) as keyof typeof symbol]).slice(-2),
    );

    return formatted.replace(/(y+)/g, (v) => targetDate.getFullYear().toString().slice(-v.length));
  };

  // 現在日＋曜日の取得
  // return "YYYY-MM-DD(week)"
  const getDateAndWeek = (): string => {
    const today = new Date();
    const week = ["日", "月", "火", "水", "木", "金", "土"];

    const date = `${today.getFullYear()}-${("00" + (today.getMonth() + 1)).slice(
      -2,
    )}-${("00" + today.getDate()).slice(-2)}(${week[today.getDay()]})`;

    return date;
  };

  // 現在日の取得
  // return "YYYY-MM-DD"
  const getDate = (): string => {
    const today = new Date();
    const date = `${today.getFullYear()}-${("00" + (today.getMonth() + 1)).slice(
      -2,
    )}-${("00" + today.getDate()).slice(-2)}`;

    return date;
  };

  // 現在日時の取得
  // return "YYYYMMDDhhmmss"
  const getDateTime = (): string => {
    const now = new Date();
    const str = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(
      2,
      "0",
    )}${String(now.getDate()).padStart(2, "0")}${String(now.getHours()).padStart(
      2,
      "0",
    )}${String(now.getMinutes()).padStart(2, "0")}${String(now.getSeconds()).padStart(2, "0")}`;
    return str;
  };

  // 翌月末日の取得
  // return "YYYY-MM-DD"
  const getLastDateOfNextMonth = (): string => {
    const today = new Date();

    const LastDateOfNextMonth = new Date(
      today.getFullYear(),
      today.getMonth() + 2, // 翌月の取得
      0, // 日に0を入れることで末日を取得できる
    );

    const convertedDate = `${LastDateOfNextMonth.getFullYear()}-${(
      "00" +
      (LastDateOfNextMonth.getMonth() + 1)
    ).slice(-2)}-${("00" + LastDateOfNextMonth.getDate()).slice(-2)}`;

    return convertedDate;
  };

  // 日時のYYYY-MM-DDの年月日曜日文字列変換
  // return "YYYY年MM月DD日(曜日)" または "YYYY年MM月DD日" または ""
  const conversionDate = (date?: string, isAddDayWeek = true): string => {
    if (date) {
      const dateMin = new Date(DATE_MIN_STRING);
      const dateMax = new Date(DATE_MAX_STRING);

      const dayWeek = ["(日)", "(月)", "(火)", "(水)", "(木)", "(金)", "(土)"];
      const day = new Date(date);

      let dateString =
        day < dateMin
          ? toJaJPDateStringYYYYMMDD(dateMin)
          : dateMax < day
            ? toJaJPDateStringYYYYMMDD(dateMax)
            : toJaJPDateStringYYYYMMDD(day);

      if (isAddDayWeek) {
        dateString += dayWeek[day.getDay()];
      }

      return dateString;
    } else {
      return "";
    }
  };

  /**
   * "YYYY年MM月DD日"形式の日付文字列へ変換する
   * @param date Dateオブジェクト
   * @returns "YYYY年MM月DD日"形式の日付文字列
   */
  const toJaJPDateStringYYYYMMDD = (date: Date): string =>
    `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;

  // 日時のYYYY-MM-DD hh:mm:ssの年月日時分秒文字列変換
  // return "YYYY/MM/DD" または "YYYY/MM/DD hh:mm" または "YYYY/MM/DD hh:mm:ss" または ""
  // -を含む日付情報の場合、Safariの表示がNaNとなるため変換を行う
  const conversionDateTime = (
    date?: string,
    isAddHoursMinutes = true,
    isAddSeconds = false,
  ) => {
    if (date) {
      const day = new Date(date.replace(/-/g, "/"));

      let dateString =
        day.getFullYear() +
        "/" +
        String(day.getMonth() + 1).padStart(2, "0") +
        "/" +
        String(day.getDate()).padStart(2, "0");

      if (isAddHoursMinutes) {
        dateString +=
          " " +
          String(day.getHours()).padStart(2, "0") +
          ":" +
          String(day.getMinutes()).padStart(2, "0");
      }

      if (isAddSeconds) {
        dateString += ":" + String(day.getSeconds()).padStart(2, "0");
      }

      return dateString;
    } else {
      return "";
    }
  };

  /**
   * "YYYY年MM月DD日"形式の日付文字列へ変換する
   * @param string
   * @returns "YYYY年MM月DD日"形式の日付文字列
   */
  const convertDateFormat = (date: string) => {
    return date.slice(0, 4) + "年" + date.slice(5, 7) + "月" + date.slice(8, 10) + "日";
  };

  /**
   * 前後の日を取得する
   * @param {string} date - 日付(YYYY-MM-DD)
   * @param {string} specify - 何日後を指定するか(マイナスの場合は何日前)
   * @returns {string} - 指定の日付(YYYY-MM-DD)
   */
  const getSpecifyDay = (date: string, specify: number) => {
    const baseDate = new Date(date);
    baseDate.setDate(baseDate.getDate() + specify);

    // NOTE: getMonth()は1月の場合0、2月の場合1と普通の月と比べて1少ない数を返却します
    const year = baseDate.getFullYear();
    const month = zeroPadding(baseDate.getMonth() + 1, 2);
    const day = zeroPadding(baseDate.getDate(), 2);

    return `${year}-${month}-${day}`;
  };

  /**
   * Todo: {◯ヶ月/◯年}{前/後}を変数で受け取るなどして1つの関数に集約する
   * 1年後("date"当日も含む)の日付を指定する
   * @param {string} date - 日付(YYYY-MM-DD)
   * @returns {string} - 1年後の日付(YYYY-MM-DD)
   */
  const getNextYear = (date: string) => {
    const baseDate = new Date(date);
    baseDate.setFullYear(baseDate.getFullYear() + 1);
    // "date"当日も含むため、1年後は同じ日付にならない=日付を-1
    baseDate.setDate(baseDate.getDate() - 1);

    // NOTE: getMonth()は1月の場合0、2月の場合1と普通の月と比べて1少ない数を返却します
    const year = baseDate.getFullYear();
    const month = zeroPadding(baseDate.getMonth() + 1, 2);
    const day = zeroPadding(baseDate.getDate(), 2);

    return `${year}-${month}-${day}`;
  };

  /**
   * Todo: {◯ヶ月/◯年}{前/後}を変数で受け取るなどして1つの関数に集約する
   * 1ヶ月後("date"当日も含む)の日付を指定する
   * @param {string} date - 日付(YYYY-MM-DD)
   * @returns {string} - 1ヶ月後の日付(YYYY-MM-DD)
   */
  const getNextMonth = (date: string) => {
    const baseDate = new Date(date);
    baseDate.setMonth(baseDate.getMonth() + 1);
    // "date"当日も含むため、1ヶ月後は同じ日付にならない=日付を-1
    baseDate.setDate(baseDate.getDate() - 1);

    // NOTE: getMonth()は1月の場合0、2月の場合1と普通の月と比べて1少ない数を返却します
    const year = baseDate.getFullYear();
    const month = zeroPadding(baseDate.getMonth() + 1, 2);
    const day = zeroPadding(baseDate.getDate(), 2);

    return `${year}-${month}-${day}`;
  };

  /**
   * 指摘桁数の0埋め
   */
  const zeroPadding = (no: number, digit: number) => {
    return ("0".repeat(digit) + no).slice(-1 * digit);
  };

  // 文字操作 =================================================================
  // 全角のアルファベット、数字、特定の記号（電話番号に使用される文字）を半角文字に変換
  const convertFullWidth2HalfWidth = (str: string) => {
    // NOTE: ハイフンに似てる記号が多いので、別途置換処理を入れる
    return str
      .replace(/[Ａ-Ｚａ-ｚ０-９＃（）]/g, function (s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
      })
      .replace(HYPHEN_CANDIDATES, "-");
  };

  // 全角記号を半角記号に変換
  const convertFullWidthSymbolToHalfWidth = (value: string) => {
    return value
      .replace(/[\uFF01-\uFF5E]/g, (s) =>
      String.fromCharCode(s.charCodeAt(0) - 0xfee0)
    )
      .replace(/\u3000/g, " "); // 全角スペース
  };

  // 全角数字は維持しつつ、全角記号を半角記号に変換
  const convertFullWidthSymbolToHalfWidthKeepFullWidthNumber = (value: string) => {
    return value
      .replace(/[\uFF01-\uFF0F\uFF1A-\uFF5E]/g, (s) =>
      String.fromCharCode(s.charCodeAt(0) - 0xfee0)
    )
      .replace(/\u3000/g, " "); // 全角スペース
  };

  // デフォルト用
  const deleteLimitedCharacter = (value: string) => {
    return value
      .replace(/[^A-Za-z0-9ぁ-んァ-ヶー一-龥々\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A\-_.()\[\]+*, 【】]/g, "");
  };

  // 改行有デフォルト用
  const deleteLimitedCharacterWithoutLineBreak = (value: string) => {
    return value.replace(
      /[^A-Za-z0-9ぁ-んァ-ヶー一-龥々\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A!#$%&'*/=?^`{|}~\uFF61-\uFF9F\u2460-\u2473\r\n、。「」 \-_.()\[\]+,【】]/g,
      ""
    );
  };

  // 半角英数字以外の消去
  const deleteCharacterExceptAlphanumeric = (str: string) => {
    return str.replace(/[^A-Za-z0-9]/g, "");
  };

  // 文字列(数字以外)の消去
  const deleteCharacterExceptDecimal = (str: string) => {
    return str.replace(/[^0-9]/g, "");
  };

  // 数字とハイフン以外の消去
  const deleteCharacterExceptDecimalHyphen = (str: string) => {
    return str.replace(/[^0-9-]/g, "");
  };

  // 数字と小数点以外の消去
  const deleteCharacterExceptDecimalPoint = (str: string) => {
    return str.replace(/[^0-9.]/g, "");
  };

  // 先頭のマイナスと数字・小数点以外の消去
  const deleteCharacterExceptDecimalPointAndHeadHyphen = (str: string) => {
    return str.replace(/(?!^)-|[^0-9.-]/g, "");
  };

  // 半角英数字記号以外の消去
  const deleteCharacterExceptAlphanumericAndSymbols = (str: string) => {
    return str.replace(/[^A-Za-z0-9!-/:-@¥[-`{-~]/g, "");
  };

  // 4バイト文字以上の消去
  const deleteCharacterOver4Bytes = (str: string) => {
    return str.replace(/[\u{10000}-\u{10FFFF}]/gu, "");
  };

  // その他 =================================================================
  // 数値チェック 符号あり小数 (+, – 許容)
  // 全角文字は文字扱いとして、数値としては判定しない
  const isNumber = (val: string) => {
    const regexp = new RegExp(/^[+,-]?([1-9]\d*|0)(\.\d+)?$/);
    return regexp.test(val);
  };

  /**
   * 初回の実行がスキップされるuseEffect
   * @param {EffectCallback} fn
   * @param {DependencyList} deps
   */
  const useEffectSkipFirstTime = (fn: EffectCallback, deps: DependencyList) => {
    const didMountRef = useRef(false);

    useEffect(() => {
      if (!didMountRef.current) {
        didMountRef.current = true;
      } else {
        fn();
      }
    }, deps);
  };

  /**
   * オブジェクトを配列に変換してソート
   * 現在の利用用途登録編集画面にて、入力途中で戻るボタンを押下した場合にメッセージを出すためのチェック処理で利用
   * @param {object} obj
   */
  const objectSort = (obj: object) => {
    // オブジェクトをソート済の配列に変換
    const sortObj = Object.entries(obj).sort();

    // オブジェクト内のオブジェクトの存在チェック
    for (const i in sortObj) {
      const sortObjVal = sortObj[i][1];
      if (typeof sortObjVal === "object" && sortObjVal) {
        // オブジェクトが存在していた場合、そのオブジェクトをソート
        sortObj[i][1] = objectSort(sortObjVal);
      }
    }
    return sortObj;
  };

  const getLabelMonth = (dateStr: string) => {
    const m = moment(dateStr);
    if (!m.isValid()) throw Error("Invalid date str " + dateStr);
    const month = m.month() + 1;
    const year = m.year();
    return `${year}年${month}月`;
  };

  /**
   * URLに新たなクエリパラメータを追加
   * 対象のURLのクエリパラメータの有無に関わらず、追加でクエリパラメータを付与
   * @param {string} fullUri
   * @param {Map<string, string>} addQueryObj
   * @returns {string} URL
   */
  const addQueryString = (fullUri: string, addQueryObj: Map<string, string>): string => {
    if (fullUri === "" || addQueryObj.size === 0) {
      // 追加元のURLが空の場合または、追加クエリパラメータが存在しない場合、
      return fullUri;
    }

    const fullUriList = fullUri.split("?");
    // 「?」が複数含まれる場合はURL体系が正しくないため、そのまま返却する
    if (fullUriList.length > 2) {
      return fullUri;
    }

    const queryObj = new URLSearchParams();
    addQueryObj.forEach((value, key) => {
      // クエリパラメータを追加
      queryObj.set(key, value);
    });

    if (fullUriList.length === 1) {
      // 追加元のURLにクエリパラメータが存在しない場合
      return `${fullUriList[0]}?${queryObj.toString()}`;
    } else {
      // 追加元のURLにクエリパラメータが存在する場合
      return `${fullUriList[0]}?${queryObj.toString()}&${fullUriList[1]}`;
    }
  };

  return {
    validateForm,
    validatesForms,
    validatesForm,
    accessLocalStorage,
    getDate,
    getDateAndWeek,
    getDateTime,
    getLastDateOfNextMonth,
    convertFullWidth2HalfWidth,
    convertFullWidthSymbolToHalfWidth,
    convertFullWidthSymbolToHalfWidthKeepFullWidthNumber,
    deleteLimitedCharacter,
    deleteLimitedCharacterWithoutLineBreak,
    deleteCharacterExceptAlphanumeric,
    deleteCharacterExceptDecimal,
    deleteCharacterExceptDecimalHyphen,
    deleteCharacterExceptDecimalPoint,
    deleteCharacterExceptDecimalPointAndHeadHyphen,
    deleteCharacterExceptAlphanumericAndSymbols,
    deleteCharacterOver4Bytes,
    isNumber,
    conversionDate,
    conversionDateTime,
    useEffectSkipFirstTime,
    objectSort,
    getLabelMonth,
    toDate,
    toYYYYMMDD,
    addYears,
    addDays,
    getNextDay,
    getPreviousDay,
    getFormattedDate,
    convertDateFormat,
    getSpecifyDay,
    getNextYear,
    getNextMonth,
    zeroPadding,
    addQueryString,
  };
};
